import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CursorStateProvider } from "./context/cursorStateContext";
import { CursorPositionProvider } from "./context/cursorPositionContext";

ReactDOM.render(
  <React.StrictMode>
    <CursorStateProvider>
      <CursorPositionProvider>
        <App />
      </CursorPositionProvider>
    </CursorStateProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
